import { render, staticRenderFns } from "./DetailRegularUser.vue?vue&type=template&id=13a3155c&scoped=true&"
import script from "./DetailRegularUser.vue?vue&type=script&lang=js&"
export * from "./DetailRegularUser.vue?vue&type=script&lang=js&"
import style0 from "./DetailRegularUser.vue?vue&type=style&index=0&id=13a3155c&scoped=true&lang=css&"
import style1 from "./DetailRegularUser.vue?vue&type=style&index=1&id=13a3155c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3155c",
  null
  
)

export default component.exports